<template>
  <div class="u-wrap">
    <div>
      <u-subsection :list="list" :current="current" @change="change"></u-subsection>
    </div>
    <div class="u-menu-wrap">
      <van-empty v-if="!isShow" description="暂无数据" />

      <div v-else style="width: 100vw">
        <div class="top_tab">
          <div class="base_info">
            <span class="tag_title">
              <img src="@images/dbsz.png" class="img"  />
            </span>
            <div v-if="obj.tp" class="zbxx">
              <img :src="obj.tp" class="tp" @click="preImage(obj.tp)" />
              <div class="zbxx-item item-left">
                <div class="text">成员总数</div>
                <div class="value">{{obj.bzrs}}</div>
              </div>
            </div>
            <div v-else class="zbxx">
              <div class="zbxx-item">
                <div class="text">成员总数</div>
                <div class="value">{{obj.bzrs}}</div>
              </div>
            </div>
          </div>
        </div>
        <lwbz-card :list="dataList"></lwbz-card>
         <bottom-lwbz :ydl="obj.ydl" :dzs ="obj.dzl"  :obj="obj"></bottom-lwbz> 
      </div>

    </div>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import uSubsection from '@/components/page/u-subsection.vue'
import lwbzCard from '@/views/common/lwbz-card.vue'
import bottomLwbz from '@/views/common/bottom-lwbz.vue'
import { ImagePreview } from 'vant'
export default {
  components: {
    uSubsection,
    lwbzCard,
    bottomLwbz,
  },
  data() {
    return {
      current: 0, // 预设当前项的值
      list: [ { name: '村(居)委会' }, { name: '监委会' }],
      keyword: '',
      dataList: [],
      typeArr: [ '03', '02'], //01,02,03
      searchType: '03',
      pageNo: 0,
      isShow: false,
      obj:{},
    }
  },
  created() {
    // this.onRefresh();
    this.getData()
  },
  computed: {},
  methods: {
    change(index) {
      this.current = index
      let i = Number(index)
      this.searchType = this.typeArr[i]
      this.clearData()
      this.getData()
    },
    clearData() {
      this.obj = {};
      this.dataList = []
    },
    getData() {
      let openId = this.$store.getters.openId
      let params = { searchType: this.searchType, openId: openId }
      getAction('/zhshj/csqxxgllwbz/lwbz/data', params).then((res) => {
        let list = res.result
        if(list&&list.length>0){
              let obj = list[0]
            this.dataList = obj.bzcyList;
            this.obj = obj;
            this.isShow = true
        }else{
          this.isShow = false
        }
      
      })
    },
      preImage(img){
      let list = [];
      list.push(img);
       ImagePreview({
        images: list,
      })
    }
  },
}
</script>

<style lang="less" scoped>
// @import '../../assets/less/whon-theme.less';
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.u-menu-wrap {
  flex: 1;
}

.u-search {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  background-color: #eeeeef;
}

.u-btn {
  background-color: #3e78f7;
  color: #fff;
  font-size: 14px;
  padding: 2px 12px;
  line-height: 26px;
  margin-left: 12px;
  border-radius: 4px;
}

.input {
  flex: 1;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  padding-left: 8px;
  font-size: 14px;
}

::v-deep .van-pull-refresh {
  min-height: 100%;
}

.top_tab {
  width: 100%;
  height: 140px;
  background: url('~@images/top-bg.jpg') no-repeat;
  background-size: cover;
  position: relative;
}
.base_info {
  width: 55%;
  overflow: hidden;
  padding: 6px;
  height: 80px;
  background-image: -webkit-radial-gradient(25% 25%, #fffdfc, #ffeee2);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(14, 72, 117, 0.5);
}
.tag_title {
  display: block;
  width: 50px;
  height: 50px;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background: #fb6767;
  position: absolute;
  top: -25px;
  right: -25px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.tag_title .img {
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 0px;
  right: 17px;
  transform: rotate(45deg);
  -webkit-transform: rotate(-45deg);
  font-size: 12px;
}

.tp{
  width: 56px;
  height: 56px;
}

.zbxx {
  display: flex;
  margin-top: 20px;



  .zbxx-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .text {
      color: #848484;
      font-size: 14px;
      margin-bottom: 8px;
    }
    .value {
      background: rgba(255, 100, 8, 0.08);
      border: 1px solid #ffe5d7;
      color: #ff5400;
      font-weight: bold;
      padding: 4px 8px;
      box-sizing: border-box;
    }
  }

    .item-left{
      align-items: flex-start;
      padding-left: 10px;
  }
}
</style>
